import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePageViewTracker } from "../lib/analytics";

/**
 * Scrolls window to the top whenever the route changes,
 * and fires anonymous page-view tracking for the public site.
 * Mount it inside <BrowserRouter> alongside <Routes>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  usePageViewTracker();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
